import { render, staticRenderFns } from "./WorkRequestDeleteItem.vue?vue&type=template&id=2820b51c&"
import script from "./WorkRequestDeleteItem.vue?vue&type=script&lang=ts&"
export * from "./WorkRequestDeleteItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports